import React, { useState } from 'react';
import './index.css'
import { Country }  from 'country-state-city';



function PhoneInput({Icon,keyInput,handleUpdateVisoriaInfo}) {
  const [maskNumber, setMaskNumber] = useState('')
  const [countries, setCountries] = useState(Country.getAllCountries())
  const [selectPhoneCode, setSelectPhoneCode] = useState('52');
  const isSafari = ()=>{
    const userAgent = navigator.userAgent
    return /Safari/.test(userAgent) && !/Chrome/.test(userAgent)
  }

  const handleChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Solo números
    let formattedValue = value;
    let mask = ''
    if(value.length <= 3){
        mask = `${mask}${formattedValue.slice(0,3)}`
    } else if(value.length > 3 && value.length < 7){
        mask = `${formattedValue.slice(0,3)}-${formattedValue.slice(3,6)}`
    }else{
        mask = `${formattedValue.slice(0,3)}-${formattedValue.slice(3,6)}-${formattedValue.slice(6)}`
    }
    setMaskNumber(mask)
    handleUpdateVisoriaInfo(e,keyInput)

  };
  const handleSelectPhoneCode = (e)=>{
    handleUpdateVisoriaInfo(e, 'phoneCode')
    setSelectPhoneCode(e.target.value)
    
  }
  return (
    <div className={`phone-input-container ${isSafari() && 'phone-input-container-safari'}`}>
        <select 
        onChange={e => handleSelectPhoneCode(e)}
        value={selectPhoneCode}

        >
            {
                countries?.map((country)=>(
                    <option 
                    value={country.phonecode} >
                        {country?.flag}  {country?.name}
                    </option>
                ))
            }

        </select>
      <input
        type="text"
        value={maskNumber}
        onChange={handleChange}
        placeholder="477-901-1989"
        maxLength="12" // Limita la longitud a la cantidad de caracteres del formato (###) ###-####
      />
      {Icon}
    </div>
  );
}

export default PhoneInput;
